import { ReactElement } from 'react'
import { SectionTitle } from './SectionTitle'
import SegmentControl from 'app/components/viz/SegmentControl'
import { SlippingGrid } from './SlippingGrid'
import type { SlippingScope, UseVoiceAgentOpsReturn } from './useVoiceAgentOps'
import { SLIPPING_THRESHOLD_LABEL } from './voiceAgentOpsMetrics'

const SLIPPING_SCOPE_OPTIONS: { value: SlippingScope; label: string }[] = [
  { value: `slipping`, label: `Slipping` },
  { value: `all`, label: `All Locations` },
]

type SlippingOverTimeSectionProps = Pick<
  UseVoiceAgentOpsReturn,
  `isSlippingLoading` | `slippingRows` | `slippingScope` | `setSlippingScope`
>

/** AI Agent locations day by day through today: green on days with AI calls, red on days without. */
export function SlippingOverTimeSection({
  isSlippingLoading,
  slippingRows,
  slippingScope,
  setSlippingScope,
}: SlippingOverTimeSectionProps): ReactElement {
  const isSlippingView = slippingScope === `slipping`

  return (
    <div className="mb-8">
      <div className="mb-1 flex flex-wrap items-center justify-between gap-2">
        <SectionTitle title="Slipping Over Time" badge={`${slippingRows?.length ?? 0} Locations`} />
        <SegmentControl
          label="Show"
          buttons={SLIPPING_SCOPE_OPTIONS.map((option) => ({
            label: option.label,
            onClick: () => setSlippingScope(option.value),
            isActive: slippingScope === option.value,
          }))}
        />
      </div>
      <p className="mb-3 text-body-sm text-subtle">
        {isSlippingView
          ? `AI Agent locations with no AI call in the last ${SLIPPING_THRESHOLD_LABEL}, day by day through today. Green days had AI calls; red days had none.`
          : `Every AI Agent location, day by day through today. Green days had AI calls; red days had none.`}
      </p>
      <SlippingGrid
        rows={slippingRows}
        isLoading={isSlippingLoading}
        emptyMessage={
          isSlippingView
            ? `Every AI Agent location has had an AI call in the last ${SLIPPING_THRESHOLD_LABEL}.`
            : `No AI Agent locations in scope.`
        }
      />
    </div>
  )
}
